/* global femcare */

femcare.shared.verticalTabs = {

    init: function () {
        var $elements = $('.vertical-tabs');

        if ($elements.length) {
            $elements.each(function (index, element) {
                var $element = $(element);
                var $tabs = $element.find('.vertical-tabs__body').tabs();

                var $select = $element.find('select');
                $select.selectmenu({
                    position: { my : 'center top', at: 'center bottom' },
                    change: function (e, ui) {
                        var $tab = $element
                            .find('.vertical-tabs__tab-link')
                            .eq(ui.item.index);
                        $tab.click();
                    }
                });

                $tabs.on('tabsactivate', function (e, ui) {
                    $select.val(ui.newTab.index());
                    $select.selectmenu('refresh');
                });
            });
        }
    }
}